import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'mdm-input-options-select',
    templateUrl: './input-options-select.component.html',
    styleUrls: ['./input-options-select.component.scss'],
    standalone: false
})
export class InputOptionsSelectComponent implements OnInit {

  @Input() options: Array<any>;
  @Input() label: string;
  @Input() control: UntypedFormControl;
  @Input() bindAllObject: boolean = true;
  @Input() readonly: boolean = false;
  @Output() onSelectClear = new EventEmitter();
  @Output() onSelectChange = new EventEmitter();

  constructor() { }

  ngOnInit(): void {}
  
  cleared() {
    this.onSelectClear.emit();
  }

  changed(event) {
    this.onSelectChange.emit(event);
  }

}
